import { mergeArrays } from '@utils-clean/array-helpers';
import NotFound from '../../views/components/not-found/not-found';
import TermsConditions from '../../views/pages/uam/terms-conditions';
import { IRoute } from './interfaces';
import { PublicPaths } from '@config/routes/paths';

const location = {
    state: {
        layout: 'PUBLIC',
    },
};

// IMPORTANT - For any new routes, the key and path must be added to paths.tsx and the path prop should be excluded from this file

const PublicRoutes: IRoute[] = mergeArrays(
    PublicPaths,
    [
        {
            key: 'terms',
            component: TermsConditions,
            location,
        },
        {
            exact: true,
            key: '/public/500',
            location,
            component: NotFound,
        },
        {
            location,
            key: '/public/404',
            component: NotFound,
        },
    ],
    (item) => item.key,
);

export default PublicRoutes;
